import { render, staticRenderFns } from "./CommonSubportionStatusRenderer.vue?vue&type=template&id=b7561d44&"
import script from "./CommonSubportionStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./CommonSubportionStatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports